import SideMenu from '@/containers/side-menu/SideMenu.vue'
import MonitorMessage from '@/pages/monitor-message/MonitorMessage'

export default [
  {
    path: '/monitor-message',
    name: 'MonitorMessage',
    components: {
      mainContent: MonitorMessage,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'monitor-message'
      },
      breadcrumb: {
        title: 'Atendimento',
        paths: [
          { title: 'Monitor' }
        ]
      }
    }
  },
  {
    path: '/monitor-message/:userToken',
    name: 'MonitorMessageAttendance',
    components: {
      mainContent: MonitorMessage,
      mainMenu: SideMenu
    },
    meta: {
      role: {
        sectorId: 'monitor-message'
      },
      breadcrumb: {
        title: 'Atendimento',
        paths: [
          { title: 'Monitor' },
          { title: 'Em conversa'}
        ]
      }
    }
  }
]